export const expensesCategories = [
  "Detailing",
  "Denting Painting",
  "Mechanical Job",
  "RTO",
  "Delivery Cost",
  "Taxes",
  "Parts",
  "Tyres",
  "Fueling",
  "Insurance",
  "Net landing cost",
];

export const paymentModes = ["Cash", "UPI", "Bank Transfer"];
